module.exports = "/call-frontend/img/icon_search_outline.34d8357b.svg";